export default [
    'bold', 'italic', 'underline', 'strikeThrough',
    'align', 'formatOL', 'formatUL', 'outdent', 'indent',
    'emoticons', 'clearFormatting', 'help', 'undo', 'redo', 'clear'
];
